import { Modal, Stack, Typography } from '@mui/material';
import React from 'react';

import { colors } from '../theme/theme';

interface NetworkDisconnectionModalProps {
    open: boolean;
    onClose: () => void;
}

const styleWrapper = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: 400,
    width: '100%',
    bgcolor: colors.fullWhite,
    p: 3,
    borderRadius: 6,
    gap: 4,
    textAlign: 'center',
    '&:focus-visible': {
        outline: 'none',
    },
};

export const NetworkDisconnectionModal: React.FC<NetworkDisconnectionModalProps> = ({ open, onClose }) => {
    return (
        <Modal
            open={open}
            onClose={(event, reason) => {
                // Prevent closing by clicking outside or pressing Escape
                if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
                    return;
                }
                onClose();
            }}
            disableEscapeKeyDown
            aria-labelledby="network-modal-title"
            aria-describedby="network-modal-description"
        >
            <Stack sx={styleWrapper}>
                <Typography id="network-modal-title" color="error" variant="h5">
                    You’re Offline
                </Typography>
                <Typography variant="body1" id="network-modal-description" color="textSecondary">
                    It looks like you’re not connected to the internet. Once you’re back online, please try again.
                </Typography>
            </Stack>
        </Modal>
    );
};
